import React, { useEffect, useState } from 'react'
import Form from "./InfluencerForm";
import LineSteps from './LineSteps';
import Choice from './Choice';
import Confirmation from './Confirmation';
import { TYPE_AGENCY, TYPE_INFLUENCER } from '../../constants';
import AgencyForm from './AgencyForm';
import CheckEmail from './CheckEmail';
import { FormattedMessage } from 'react-intl';

const Register = () => {
    const [step, setStep] = useState(0)
    const [choice, setChoice] = useState(TYPE_INFLUENCER)
    const [formData, setFormData] = useState({})


    useEffect(() => {
        console.log("formData: ", formData);
    }, [formData]);

    return (
        <>
            <div className='flex  bg-white'>

                <div className="hidden lg:flex bg-primary min-h-[100vh]  shadow-2xl  flex-col justify-center  flex-grow py-5 px-5 space-y-8  w-[30%] rounded-r-xl">
                    <img src="/images/logo-white.png" className='w-[150px]' />

                    <h1 className="text-5xl mt-16 text-white font-bold">
                        <FormattedMessage id="lets_setup" defaultMessage={"Let's Setup"} /> <br />
                        <FormattedMessage id="your_influencee_account" defaultMessage={"your influencee account"} />
                    </h1>
                    {/* <hr className="h-[4px] w-1/2" /> */}
                    {/* <div className="text-white font-light">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        Lorem Ipsum is simply dummy text of the printing.
                    </div> */}

                </div>
                {
                        step === 3 ?
                        <CheckEmail />
                        :
                        <div className="w-full lg:w-[70%] mx-auto h-full">
                    {
                        step !==3 && <LineSteps step={step} setStep={setStep} />
                    }

                    <div className=" w-[90%] md:w-[80%] xl:w-[60%] mx-auto px-4 pt-16 pb-10  md:rounded-[20px]">
                        {
                            step === 0 ?
                                <Choice setStep={setStep} setChoice={setChoice} />
                                :
                                step === 1 ?
                                    choice === TYPE_INFLUENCER ?
                                        <Form setFormData={setFormData} formData={formData} setStep={setStep} />
                                        :
                                        choice === TYPE_AGENCY ?
                                            <AgencyForm setFormData={setFormData} formData={formData} setStep={setStep} />
                                            : ""
                                : step === 2 ?
                                    <Confirmation setStep={setStep} formData={formData} />
                                : ""
                                

                        }
                    </div>
                    
                </div>
                    }


                

            </div>

        </>
    )
}

export default Register